import { useState, useEffect } from 'react';
import { useGetRequest } from './requests';
import { EMBED_USER_ME } from '../utils/urls';

/**
 * Hook to fetch and store current embed user data
 * @returns {Object} { user, loading, error, refetch }
 */
export function useEmbedUser() {
    const [user, setUser] = useState(null);
    const getUserRequest = useGetRequest({ url: EMBED_USER_ME });

    useEffect(() => {
        // Try to load from localStorage first
        const cachedUser = localStorage.getItem('embed_user');
        if (cachedUser) {
            try {
                const parsedUser = JSON.parse(cachedUser);
                setUser(parsedUser);
                // Don't fetch if we have valid cached data
                return;
            } catch (e) {
                console.error('[useEmbedUser] Failed to parse cached user:', e);
            }
        }

        // Only fetch if we don't have cached user and we have a token
        const hasToken = localStorage.getItem('iframeToken') || localStorage.getItem('embed_access_token');
        if (hasToken) {
            fetchUser();
        }
    }, []);

    const fetchUser = async () => {
        const { response, success } = await getUserRequest.request({ showError: false });

        if (success && response) {
            const userData = {
                id: response.id,
                externalUserId: response.externalUserId,
                email: response.email,
                displayName: response.displayName,
                userType: response.userType,
                externalProvider: response.externalProvider,
                externalProjectId: response.externalProjectId,
            };

            setUser(userData);

            // Cache in localStorage
            localStorage.setItem('embed_user', JSON.stringify(userData));
            localStorage.setItem('userId', String(userData.id));
            if (userData.displayName) {
                localStorage.setItem('userName', userData.displayName);
            }
            if (userData.email) {
                localStorage.setItem('userEmail', userData.email);
            }

            return userData;
        }

        return null;
    };

    return {
        user,
        loading: getUserRequest.loading,
        error: getUserRequest.error,
        refetch: fetchUser,
    };
}
